export default __webpack_public_path__ + "static/efficiency-2e50fb2ee56c84f5e9f2fe4aa2a45ae3.png";